import { useTranslation } from "react-i18next";
import { DateUtils } from "../../../../../utils";
import './AdditionalDocCard.scss';
import { useHistory } from "react-router-dom";

export const AdditionalDocCard = ({
  addDoc, petition, hasAction = true
}) => {
  const {t} = useTranslation();
  const history = useHistory();
  const clickable = hasAction && ['PENDING', 'DATA_COMPLETED', 'REGISTERED'].includes(addDoc.status);
  return (
    <button
      key={addDoc.id}
      className="AdditionalDocCard"
      type="button"
      aria-label={t('Globals.seeRequest')}
      onClick={clickable ? () => {
        if (addDoc.status === 'REGISTERED') history.push(`/petitions/${petition.petitionId}/additional-documents/${addDoc.id}`, {
          petition: petition
        })
        else history.push(`/petitions/${petition.petitionId}/additional-documents/new`, {
          additionalDocs: true, procedureId: addDoc.id, petition
        })
      } : null}
    >
      <img 
        className='icon-left'
        src={addDoc.status === 'REGISTERED' ? "/misc/icons/step-ok.png" : "/misc/icons/status-pendingDoc.png"}
        alt=" "
      />
      <div className="document-data">
        <div className="document-data-row">
          <div className="document-column">
            <p className="document-column-title">{t('Petitions.additionalDocs.additionalDocsList.status')}</p>
            <p className="document-column-value">{addDoc.statusTitle}</p>
          </div>
          <div className="document-column">
            <p className="document-column-title">{t('Petitions.additionalDocs.additionalDocsList.creationDate')}</p>
            <p className="document-column-value">{DateUtils.getFormatedDate(addDoc.creationTime)}</p>
          </div>
          <div className="document-column">
            <p className="document-column-title">{addDoc.status === 'REGISTERED' ? t('Petitions.additionalDocs.additionalDocsList.presentationDate') : t('Petitions.additionalDocs.additionalDocsList.updateTime')}</p>
            <p className="document-column-value">{DateUtils.getFormatedDate(addDoc.statusTime)}</p>
          </div>
          {
            addDoc.registerNumber && (
              <div className="document-column">
                <p className="document-column-title">{t('Petitions.additionalDocs.additionalDocsList.registerNumber')}</p>
                <p className="document-column-value">{addDoc.registerNumber}</p>
              </div>
            )
          }
        </div>
      </div>
    </button>
  );
}